import { deleteIcon, editIcon } from "../../../assets/Icons/icons";
import { isRtlLanguage, removeQuotes } from "./utils";
import { strings } from "../../../strings/strings";

const StaticStringsTable = ({ data, activeLang, onEditClick, onDeleteClick }) => {
  const rtl = isRtlLanguage(activeLang);

  if (!data?.results?.strings?.length) {
    return (
      <div className="text-center py-12">
        <p className="text-lg font-semibold text-secondary mb-2">{strings.nostringsfound}</p>
        <p className="text-gray-500 mb-6">
          {strings.nostringsavailablefor}
          {activeLang}.
        </p>

      </div>
    );
  }

  return (
    <div>
      <div className="overflow-x-auto rounded-2xl shadow-lg border border-gray-200 max-w-full">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-primary border-b-2 border-primary/20">
              <th className="px-8 py-4 text-left text-xs font-bold text-white uppercase tracking-wider">
                {strings.keyLabel}
              </th>
              <th className="px-8 py-4 text-left text-xs font-bold text-white uppercase tracking-wider">
                {strings.valueLabel}
              </th>
              <th className="px-8 py-4 text-center text-xs font-bold text-white uppercase tracking-wider">
                {strings.action}
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            {data.results.strings.map((item) => {
              const stringKey = removeQuotes(item.string_key);
              const stringValue = removeQuotes(item.value);

              return (
                <tr
                  key={item.id}
                  className="hover:bg-gradient-to-r hover:from-primary/5 hover:to-transparent transition-all duration-200 group"
                >
                  <td className="px-8 py-5">
                    <span className="text-sm text-secondary font-medium">{stringKey}</span>
                  </td>
                  <td className="px-8 py-5" style={rtl ? { textAlign: "right" } : undefined}>
                    <span
                      dir={rtl ? "rtl" : "ltr"}
                      className={`block w-[300px] sm:w-full text-sm text-secondary font-medium ${
                        rtl ? "text-right" : "text-left"
                      }`}
                      style={rtl ? { direction: "rtl", unicodeBidi: "plaintext", textAlign: "right" } : undefined}
                    >
                      {stringValue}
                    </span>
                  </td>
                  <td className="px-4 py-5">
                    <div className="flex gap-3 justify-center items-center">
                      <button
                        onClick={() => onEditClick(item)}
                        className="p-2 rounded-lg bg-blue-50 hover:bg-blue-100 text-primary hover:text-blue-700 transition-all duration-200 hover:scale-110 shadow-sm hover:shadow-md"
                        title={strings.edit}
                      >
                        <img src={editIcon} alt="edit" className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => onDeleteClick(item.id)}
                        className="p-2 rounded-lg bg-red-50 hover:bg-red-100 text-red-600 hover:text-red-700 transition-all duration-200 hover:scale-110 shadow-sm hover:shadow-md"
                        title="Delete"
                      >
                        <img src={deleteIcon} alt="delete" className="w-4 h-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StaticStringsTable;
